// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"ChangeViewerButton_iconStyle_15dyW","iconImageStyle":"ChangeViewerButton_iconImageStyle_2DG63","buttonIconPosition":"ChangeViewerButton_buttonIconPosition_1_cX1"};